import { NodeViewWrapper } from '@tiptap/react';
import { useCallback, useMemo } from 'react';

export default function GalleryNodeView({ node, updateAttributes, selected }) {
  const images = useMemo(() => node.attrs.images || [], [node.attrs.images]);

  const addImage = useCallback(() => {
    const src = window.prompt('Image URL', '/img/news/');
    if (!src) return;
    const alt = window.prompt('Alt text (optional)', '') || '';
    updateAttributes({ images: [...images, { src, alt }] });
  }, [images, updateAttributes]);

  const removeImage = useCallback((index) => {
    updateAttributes({ images: images.filter((_, i) => i !== index) });
  }, [images, updateAttributes]);

  return (
    <NodeViewWrapper>
      <div className={`post-gallery border-2 rounded transition-colors ${selected ? 'border-bahyellow' : 'border-gray-200'}`}>
        {images.map((img, i) => (
          <div key={i} className="relative group">
            <img src={img.src} alt={img.alt} />
            <button
              type="button"
              onClick={() => removeImage(i)}
              className="absolute top-2 right-2 bg-red-500 text-white rounded-full w-5 h-5 text-xs flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity leading-none"
            >
              ✕
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={addImage}
          className="m-1.5 h-24 w-32 border-2 border-dashed border-gray-300 rounded text-gray-400 hover:border-bahyellow hover:text-bahyellow transition-colors text-sm"
        >
          + Add image
        </button>
      </div>
    </NodeViewWrapper>
  );
}
